import React from 'react'
import Tabs from '../../Component/Tabs/Tabs'
import MenuBottom from '../../Component/menuBottom/MenuBottom'

const Orders = () => {
    return (
        <div>
            <Tabs/>
            <MenuBottom/>
        </div>
    )
}

export default Orders
